'use strict';
const angular = require('angular');

/*@ngInject*/
export function AccountingService($resource) {
  return $resource('/api/accounting/:id', {
    id: '@_id'
  },{
    balance: {
      method: 'GET',
      url: '/api/accounting/:book/balance/:account'
    },
    transactions: {
      method: 'GET',
      url: '/api/accounting/:book/transactions/:account'
    },
    entry: {
      method: 'POST',
      url: '/api/accounting/:book/entries'
    },
    void: {
      method: 'PUT',
      url: '/api/accounting/:book/void/:id'
    },
    journal: {
      method: 'GET',
      url: '/api/accounting/:book/journal',
      isArray: true
    }
  });
}


export default angular.module('conduu.AccountingService', [])
  .factory('AccountingService', AccountingService)
  .name;



// WEBPACK FOOTER //
// ./client/components/accounting/accounting.service.js